// extracted by mini-css-extract-plugin
export default {"countUp":"CountUp_countUp__zPoSe"};